import React from 'react';

import { RadioOptionsWithConfirm } from 'shared-components';

import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { savePI } from '../../../../store/student/actions';
import { createUpdateOfferFieldAction } from '../../../../store/student/offer/actions';
import { InputFieldConfig } from '../../../../types';
import { Pages } from '../../../../store/student/personalInfo/types';
import { useDispatch } from 'react-redux';
import { Box, ListItem, UnorderedList, Text } from '@chakra-ui/react';

export interface ICustomProps {
  sectionTitle: string;
  complete: boolean;
  currentStep: number;
  steps: number;
  visaSupport?: boolean;
  visaSupportVisible: boolean;
  visaSupportConfig: InputFieldConfig;
  config: any;
}

type IProps = ICustomProps;

const PersonalQPage9: React.FC<IProps> = (props: IProps) => {
  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(savePI(Pages.PAGE9, config));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  const onChange = (fieldName: string, value: any) => dispatch(createUpdateOfferFieldAction(fieldName, value));

  const handleVisaSupportClick = (question: any) => {
    onChange(Q.VISA_SUPPORT, question.char === 'Y');
  };

  return (
    <QuestionPage
      complete={props.complete}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      <RadioOptionsWithConfirm
        key={Q.VISA_SUPPORT}
        id={Q.VISA_SUPPORT}
        label={props.visaSupportConfig?.label}
        subText={
          <Box>
            <Text>Our team is here to help, with free guidance and support every step of the way.</Text>
            <UnorderedList>
              <ListItem>Expert Support: Ask questions about your application.</ListItem>
              <ListItem>Document Checks: Ensure you meet the requirements.</ListItem>
              <ListItem>Interview Preparation: Get tailored advice.</ListItem>
              <ListItem>Application Assistance: Get step-by-step help.</ListItem>
            </UnorderedList>
          </Box>
        }
        inputHelperText={props.visaSupportConfig?.helpText}
        autofocus={true}
        onClick={(question: any) => handleVisaSupportClick(question)}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: props.visaSupport === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: props.visaSupport === false,
          },
        ]}
      />
    </QuestionPage>
  );
};

export default PersonalQPage9;
